import React, { useEffect } from 'react';
import Script from 'next/script';
import SnackbarProvider from 'react-simple-snackbar';
import { RedirectedPaths } from '../utils/constants';
import { Provider, useStore } from 'react-redux';
import { AuthProvider } from '../context/authContext';
import { wrapper } from '../redux/store';
import Router from 'next/router';
import dynamic from 'next/dynamic';
import ErrorBoundary from '../components/ErrorBoundary';

const Layout = dynamic(() => import('../Layout'), { ssr: true });

const Analytics = dynamic(
  () => import('@vercel/analytics/react').then((m) => m.Analytics),
  {
    ssr: false,
  }
);
const Snackbar = dynamic(() => import('../components/Snackbar'), {
  ssr: false,
});

const GlobalComponent = ({ children, isAuth }) => {
  const [errorMsg, setShowError] = React.useState('');
  const [successMsg, setSuccessMsg] = React.useState('');
  const store = useStore((state) => state);

  const redirect = (url) => {
    try {
      const state = store.getState();
      const authState = state.auth;
      const currentUser = authState?.currentUser;
      if (RedirectedPaths[Router.asPath]) {
        Router.push(RedirectedPaths[Router.asPath]);
      }

      if (
        currentUser?.is_completed_profile &&
        !currentUser?.detail?.is_approved &&
        url !== '/totur_complete_profile' &&
        !currentUser?.detail?.is_completed_form &&
        currentUser?.user_type === 'tutor'
      ) {
        Router.push('/totur_complete_profile');
      }
    } catch (error) {
      console.error('_app.js error =======', error);
    }
  };

  useEffect(() => {
    Router.events.on('routeChangeComplete', async (url) => {
      redirect(url);
    });
    // redirect()
  }, []);
  const closeSnack = () => {
    setShowError('');
    setSuccessMsg('');
  };

  return (
    <ErrorBoundary>
      <div>
        <Snackbar
          closeToast={closeSnack}
          error={errorMsg}
          show={!!errorMsg || !!successMsg}
          message={errorMsg || successMsg}
        />
        {/* <Script
          strategy="afterInteractive"
          src="https://www.googletagmanager.com/gtag/js?id=GTM-T9WCSJ5L"
        ></Script>
        <Script strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments)};
            gtag('js', new Date());
            gtag('config', 'GTM-T9WCSJ5L');
            `}
        </Script> */}
      </div>
      <AuthProvider>
        <Layout isAuth={isAuth}>
          <Provider store={store}>
            <SnackbarProvider>{children}</SnackbarProvider>
          </Provider>
        </Layout>
      </AuthProvider>
      <Analytics />
    </ErrorBoundary>
  );
};

export default wrapper.withRedux(GlobalComponent);
